import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';
//import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'tidspunkt';
            break;
        case 'tidspunkt':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'koeretoej-nummerplade';
            break;
        case 'koeretoej-nummerplade':
            nextPage = 'hvilket-koeretoej';
            break;
        case 'hvilket-koeretoej':
            nextPage = 'var-koeretoejet-laast';
            break;
        case 'var-koeretoejet-laast':
            nextPage = 'noegler';
            break;
        case 'noegler':
            nextPage = 'mistet-noegler';
            break;
        case 'mistet-noegler':
            nextPage = 'antal-noegler';
            break;
        case 'antal-noegler':
            nextPage = 'er-koerertoejet-fundet';
            break;
        case 'er-koerertoejet-fundet':
            if (getValueOrDefault(formConfig, formValues, 'isVehicleFound').value === 'yes') {
                nextPage = 'skader';
            } else {
                nextPage = 'dokumentation';
            }
            break;
        case 'skader':
            if (
                getValueOrDefault(formConfig, formValues, 'isVehicleDamaged').value === 'yes' &&
                getValueOrDefault(formConfig, formValues, 'vehicleTypeOther').value === 'other'
            ) {
                nextPage = 'skader-andet-koeretoej';
            } else if (getValueOrDefault(formConfig, formValues, 'isVehicleDamaged').value === 'yes') {
                nextPage = 'skadezone';
            } else {
                nextPage = 'dokumentation';
            }
            break;

        case 'skader-andet-koeretoej':
            nextPage = 'dokumentation';
            break;
        case 'skadezone':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'politi-og-samtykke';
            break;

        case 'politi-og-samtykke':
            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Y') {
                nextPage = 'samtykke';
            } else {
                nextPage = 'om-virksomheden';
            }
            break;
        case 'samtykke':
            nextPage = 'om-virksomheden';
            break;
        case 'om-virksomheden':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
